<sfx-toolbar enableDivider>
    <div data-layout-align="space-between center">
        <span translate>API keys</span>
        <a mat-button [color]="media.isActive('gt-sm')?'primary':''" track-id="api-docs" [href]="apiDocsUrl" target="_blank" rel="noopener" translate>API DOCS</a>
    </div>
</sfx-toolbar>

<sfx-content>
    <ng-container *ngIf="initialLoad && (apiKeys.length < 1)">
        <sfx-empty-state image="images/api_keys_empty.png">
            <h1 class="accent" translate>No API keys created yet!</h1>
            <h1 class="accent" translate>Click the button below to create an API key.</h1>
        </sfx-empty-state>
    </ng-container>
    <sfx-section *ngIf="initialLoad && (apiKeys.length > 0)" disableContentPadding >

        <mat-grid-list [cols]="media.isActive('xs') ? 1 : media.isActive('md') ? 1 : 2" gutterSize="16px" rowHeight="182px">
            <mat-grid-tile *ngFor="let apiKey of apiKeys">
                <mat-card appearance="outlined">
                    <mat-card-header>
                        <mat-card-title><h3>{{apiKey.name}}</h3></mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <p class="ellipsis">{{apiKey.api_key}}</p>
                        <p *ngIf="apiKey.last_used" [title]="apiKey.last_used">
                            <span>{{ ('Last used:' | translate) + ' ' }}</span> <span>{{formatDate(apiKey.last_used)}}</span>
                        </p>
                        <div *ngIf="!apiKey.last_used" class="last-used-placeholder"></div>
                    </mat-card-content>
                    <mat-card-actions>
                        <button mat-button [cdkCopyToClipboard]="apiKey.api_key" track-id="copy-apikey"><span translate>Copy</span></button>
                        <button mat-button (click)="editApiKey(apiKey)" track-id="update-apikey"><span translate>Edit</span></button>
                        <button mat-button (click)="deleteApiKey(apiKey)" track-id="delete-apikey"><span translate>Delete</span></button>
                    </mat-card-actions>
                </mat-card>
            </mat-grid-tile>
        </mat-grid-list>
    </sfx-section>
</sfx-content>

<sfx-speed-dial class="fab-dial" [attr.aria-label]="'connect-email' | translate" (click)="createApiKey()">
</sfx-speed-dial>